























































































import { Component, Vue } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../../apollo";
import gql from "graphql-tag";
import IActor from "../../types/actor";
import { studioModule } from "../../store/studio";
import StudioSelector from "../../components/StudioSelector.vue";
import studioFragment from "../../fragments/studio";

@Component({
  components: {
    StudioSelector
  }
})
export default class StudioToolbar extends Vue {
  editDialog = false;
  validEdit = false;
  editName = "";
  editDescription = "";
  editParent = null as any | null;
  editAliases = [] as string[];

  studioNameRules = [v => (!!v && !!v.length) || "Invalid studio name"];

  removeDialog = false;
  removeLoader = false;

  getDomainName(url: string) {
    return new URL(url).hostname
      .split(".")
      .slice(0, -1)
      .join(".");
  }

  remove() {
    if (!this.currentStudio) return;

    this.removeLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeStudios(ids: $ids)
        }
      `,
      variables: {
        ids: [this.currentStudio._id]
      }
    })
      .then(res => {
        this.removeDialog = false;
        this.$router.replace("/studios");
      })
      .catch(err => {
        console.error(err);
      })
      .finally(() => {
        this.removeLoader = false;
      });
  }

  openRemoveDialog() {
    this.removeDialog = true;
  }

  async sleep(ms: number) {
    return new Promise(r => setTimeout(r, ms));
  }

  async editStudio() {
    if (!this.currentStudio) return;

    await this.sleep(50);

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: StudioUpdateOpts!) {
          updateStudios(ids: $ids, opts: $opts) {
            _id
            parent {
              _id
              name
            }
            substudios {
              ...StudioFragment
            }
          }
        }
        ${studioFragment}
      `,
      variables: {
        ids: [this.currentStudio._id],
        opts: {
          name: this.editName,
          description: this.editDescription,
          parent: this.editParent ? this.editParent._id : null,
          aliases: this.editAliases
        }
      }
    })
      .then(res => {
        studioModule.setName(this.editName.trim());
        studioModule.setDescription(this.editDescription.trim());
        studioModule.setParent(res.data.updateStudios[0].parent);
        studioModule.setAliases(this.editAliases);
        this.editDialog = false;
      })
      .catch(err => {
        console.error(err);
      });
  }

  openEditDialog() {
    if (!this.currentStudio) return;

    this.editName = this.currentStudio.name;
    this.editDescription = this.currentStudio.description || "";
    this.editDialog = true;
    this.editParent = this.currentStudio.parent;
    this.editAliases = this.currentStudio.aliases || [];
  }

  favorite() {
    if (!this.currentStudio) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: StudioUpdateOpts!) {
          updateStudios(ids: $ids, opts: $opts) {
            favorite
          }
        }
      `,
      variables: {
        ids: [this.currentStudio._id],
        opts: {
          favorite: !this.currentStudio.favorite
        }
      }
    }).then(res => {
      studioModule.setFavorite(res.data.updateStudios[0].favorite);
    });
  }

  bookmark() {
    if (!this.currentStudio) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: StudioUpdateOpts!) {
          updateStudios(ids: $ids, opts: $opts) {
            bookmark
          }
        }
      `,
      variables: {
        ids: [this.currentStudio._id],
        opts: {
          bookmark: this.currentStudio.bookmark ? null : Date.now()
        }
      }
    }).then(res => {
      studioModule.setBookmark(res.data.updateStudios[0].bookmark);
    });
  }

  get currentStudio() {
    return studioModule.current;
  }

  mounted() {
    /* window.addEventListener("keydown", ev => {
      if (ev.keyCode === 70) {
        this.favorite();
      } else if (ev.keyCode === 66) {
        this.bookmark();
      }
    }); */
  }
}
